import styled from '@emotion/styled/macro'
import { groupBy, mapValues } from 'lodash-es'
import {
  IPivotProps,
  Pivot,
  PivotItem,
  PivotLinkFormat,
} from 'office-ui-fabric-react'
import * as React from 'react'

const alphabet = new Array(26)
  .fill(null)
  .map((_, i) => String.fromCharCode('A'.charCodeAt(0) + i))

const StretchPivot = styled(Pivot)`
  .ms-Pivot {
    display: flex;
    flex-wrap: wrap;
    justify-content: stretch;
  }

  .ms-Pivot-link {
    flex: 1;
    padding-left: 3px;
    padding-right: 3px;

    .ms-Button-flexContainer {
      justify-content: center;
    }
  }

  .ms-Pivot-text {
    font-weight: 600;
  }

  .ms-Pivot-link:first-of-type {
    flex: 0;
    padding-left: 10px;
    padding-right: 10px;
  }
`
export type AlphabetPaginationProps = Pick<
  IPivotProps,
  'selectedKey' | 'onLinkClick'
> & {
  items: string[]
  disableAll?: boolean
}

export const AlphabetPagination: React.FunctionComponent<
  AlphabetPaginationProps
> = ({ items, selectedKey, onLinkClick, disableAll }) => {
  const countByChar = React.useMemo(() => {
    const dict = groupBy(items, (item) =>
      item ? item.charAt(0).toUpperCase() : ''
    )

    return mapValues(dict, 'length')
  }, [items])

  return (
    <StretchPivot
      headersOnly={true}
      linkFormat={PivotLinkFormat.tabs}
      selectedKey={selectedKey}
      onLinkClick={onLinkClick}
    >
      <PivotItem
        itemIcon="Search"
        headerText=""
        itemCount={disableAll ? undefined : items.length}
        itemKey="all"
        headerButtonProps={{ disabled: !!disableAll }}
        style={{ flex: 0 }}
      />
      {alphabet.map((char) => (
        <PivotItem
          key={char}
          headerText={char}
          itemCount={countByChar[char]}
          itemKey={char}
          headerButtonProps={{ disabled: !countByChar[char] }}
        />
      ))}
    </StretchPivot>
  )
}
